import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BareLayout, Seo } from "@/components/Layout";
import Logo from "@/components/Logo";
import { Compass, AlertTriangle } from "lucide-react";

export function NotFound() {
  return (
    <BareLayout>
      <Seo title="Página no encontrada" noindex />
      <div className="min-h-screen flex flex-col">
        <div className="border-b border-border p-4"><Logo /></div>
        <div className="flex-1 flex items-center justify-center p-6" data-testid="page-404">
          <div className="text-center max-w-md">
            <Compass size={48} className="mx-auto text-primary mb-6" />
            <p className="font-display font-black text-6xl">404</p>
            <h1 className="font-display font-bold text-2xl mt-2">Nos hemos perdido</h1>
            <p className="text-muted-foreground mt-2">Esta página no existe o se ha movido. Volvamos al buen camino.</p>
            <div className="mt-8 flex gap-3 justify-center">
              <Link to="/"><Button className="rounded-full">Ir al inicio</Button></Link>
              <Link to="/cursos"><Button variant="outline" className="rounded-full">Ver cursos</Button></Link>
            </div>
          </div>
        </div>
      </div>
    </BareLayout>
  );
}

export function ServerError() {
  return (
    <BareLayout>
      <Seo title="Error del servidor" noindex />
      <div className="min-h-screen flex flex-col">
        <div className="border-b border-border p-4"><Logo /></div>
        <div className="flex-1 flex items-center justify-center p-6" data-testid="page-500">
          <div className="text-center max-w-md">
            <AlertTriangle size={48} className="mx-auto text-primary mb-6" />
            <p className="font-display font-black text-6xl">500</p>
            <h1 className="font-display font-bold text-2xl mt-2">Algo ha fallado</h1>
            <p className="text-muted-foreground mt-2">Ha ocurrido un error inesperado. Inténtalo de nuevo en unos minutos.</p>
            <Link to="/"><Button className="mt-8 rounded-full">Ir al inicio</Button></Link>
          </div>
        </div>
      </div>
    </BareLayout>
  );
}
